<template>
  <div id="dps-header" />
</template>

<script lang="ts" setup>
import { nextTick, onMounted } from 'vue';

import { useDpSpacesHeaderRemote } from '../composables/use-dp-spaces-header-remote';

const { load } = useDpSpacesHeaderRemote({
  elementId: '#dps-header',
});

onMounted(async () => {
  await nextTick();
  load();
});
</script>
